import {DataNode, TreeProps} from 'antd/lib/tree';
import React, {useEffect, useState} from 'react';
import {Button, Card, Input, Modal, Tree} from 'antd';
import {DownOutlined} from '@ant-design/icons';
import Flex from '../../components/Flex';
import {SpecialtyCommitteeList, WorkCommitteeList} from '../../utils/CommitteeList';
import {useBoolean, useInput} from 'react-hanger';
import ArticleEditForm from '../../components/article/EditForm';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {ArticleApi, ArticleDto, ArticleDtoSearchResponseDto, CongressTableApi} from '../../scaffold';
import {useAntdTable} from 'ahooks';
import AntDTableUtils from '../../utils/AntDTableUtils';
import {DefaultAntdTableConfig} from '../../utils/CommonConfig';
import ArticleTable from '../../components/article/Table';
import useAuth from '../../utils/AuthContext';
import CongressTableTable from '../../components/congress/Table';
function keyToItem(key: string) {
  return {title: key, key};
}
export default function ManageCongressTablePage() {
  const keyword = useInput('');
  const searchHook = useOpenApiFpRequest(CongressTableApi, CongressTableApi.prototype.congressTableSearchGet);
  const antdConfig = useAntdTable(
    params => {
      console.log(params);
      return searchHook.request({
        ...AntDTableUtils.makeParams(params),
        keywords: keyword.value,
      });
    },
    {...DefaultAntdTableConfig, refreshDeps: []},
  );

  return (
    <div style={{flex: 1, padding: 20}}>
      <Card title={'登记表列表'}>
        <Input.Search {...keyword.eventBind} onSearch={antdConfig.refresh} style={{width: 300}} className={'m-b-10'} />
        <CongressTableTable antDTable={antdConfig} />
      </Card>
    </div>
  );
}
